<p class="primaryColor mb-2 text-2xl font-bold">#{{ orderId() }}</p>

<div class="flex justify-between">
  <div class="mt-6 mb-4 flex gap-6">
    @for (item of tabs(); track item.id) {
      <button
        class="primaryColor cursor-pointer pb-1 text-xl font-semibold"
        [class.border-b-2]="item.id === activeTab()"
        (click)="onSetActiveTab(item.id)">
        {{ item.label }}
      </button>
    }
  </div>
</div>

@if (activeTab() === 1) {
  <app-view-order-details [role]="role()" />
}

@if (activeTab() === 2) {
  <app-view-order-history
    [orderData]="{
      id: 1,
      region: { id: 1, titleEn: 'Region', titleAr: 'منطقة', profileImageFid: '' },
      pharmacy: { id: 1, nickName: 'Test Pharmacy', address: '', pharmacyOwner: { id: 3, fullName: '' } },
      pharmacySegment: { id: 1, titleEn: 'Segment', titleAr: 'قطاع', profileImageFid: '' },
      status: { id: 1, titleEn: 'Active', titleAr: 'نشط', profileImageFid: '' },
      totalItems: 5,
      totalPharmacyPrice: 100,
      createdOn: '2024-01-01',
      createdBy: { id: 1, fullName: 'Admin' },
      lastModifiedOn: null,
      lastModifiedBy: null,
      employee: { id: 1, fullName: 'test' },
      request: {
        id: 2,
        currentStatus: { id: 3, titleEn: 'Pending', titleAr: 'معلق', profileImageFid: '' },
        lastModifiedOn: '2024-01-01',
        lastModifiedBy: null,
      },
      totalQuantity: 3,
      attributes: [{ attributeKey: 'key', attributeValue: 'value' }],
    }" />
}

@if (activeTab() === 3) {
  <app-view-order-related-invoices />
}
